import axios from "axios";
import store from "../store/";
import router from "@/router";

//const domain = "http://10.23.29.28:4000";
const domain = process.env.NODE_ENV === 'production' ? 'https://ttdhnbstcapi.vnptthainguyen.vn' : 'http://localhost:4000';
const baseURL = `${domain}/api`;

const AxiosClient = axios.create({
  baseURL,
  headers: {
    device: "WEB",
    client: navigator.userAgent,
    "Cache-Control": "no-cache, no-store",
  },
});

AxiosClient.interceptors.request.use(
  function(config) {
    config.headers["x-access-token"] = localStorage.getItem("accessToken")
      ? localStorage.getItem("accessToken").toString()
      : "";
    console.log("pre-process before send axios request");
    return config;
  },
  function(error) {
    throw error;
  }
);

AxiosClient.interceptors.response.use(
  function(response) {
    console.log("Axios receive response!");
    return response;
  },
  function(error) {
    const { response } = error;

    //  Unauthorized Error: Redirect to login page
    if (response && response.status === 401) {
      store.dispatch("auth/logout");
    } else if (response.status === 402) {
      store.dispatch("ui/closeLoading");
      router.push({ path: `/license/active` }).catch(() => {});
    } else {
      throw response.data.message || "Unknow Error";
    }
  }
);

export default AxiosClient;
